import { Link } from "react-router-dom";
import CaterIndustry from "../../Sections/CaterIndustry";
import DesignWeOfffer from "../../Sections/DesignWeOffer";
import FirstTime from "../../Sections/FirstTime";
import HowItWorks from "../../Sections/HowItWorks";
import BottomNav from "../../Layout/BottomNav";
import {
  ReactCompareSlider,
  ReactCompareSliderImage,
} from "react-compare-slider";
import ImpactSection from "../../Sections/Impactsection";
import CompareTable from "../../Sections/CompareTable";
import SlickSlider from "../../Slider/SlickSlider";
import { Helmet } from "react-helmet";
import ConvertedPrice from "../ConvertedPrice";
// import './day.css'

const CommImageEnhacement = () => {
  const impactSectionData = [
    {
      frontImage: "What_impact_it_will_create_After_1_Web_1749847956.webp",
      backImage: "What_impact_it_will_create_Before_1_Web_1749847956.webp",
      icon: "features1.svg",
      title: "Improves visual appeal",
      desc: "Helps in showcasing stunning visuals and increasing appeal by up to 30%",
    },
    {
      frontImage: "What_impact_it_will_create_After_2_Web_1749847956.webp",
      backImage: "What_impact_it_will_create_Before_2_Web_1749847956.webp",
      icon: "atomosphere.svg",
      title: "Enhance atmosphere",
      desc: "Elevates atmosphere, creating up to 50% more engaging and inviting visuals",
    },
    {
      frontImage: "What_impact_it_will_create_After_3_Web_1749847956.webp",
      backImage: "What_impact_it_will_create_Before_3_Web_1749847956.webp",
      icon: "HD.svg",
      title: "High dynamic range blending",
      desc: "Enhances image quality by up to 60%, revealing every detail in vibrant clarity",
    },
  ];

  return (
    <>
      <></>

      {/* <div className="banner-content">
        <h1 data-aos="fade-up">
          Unlock the Power of Virtual Staging in Real Estate!
        </h1>
        <div className="banner-content-links">
          <Link
            className="theme-btn"
            to="/virtual-staging"
          >
            Explore Services
          </Link>
          <Link to="/try-for-free">Or, book a free trial</Link>
        </div>
      </div> */}

      <Helmet>
        <title>
          Commercial Image Enhancement at $1.5 | Pro Edits | Stagobox
        </title>
        <meta
          name="description"
          content="Make commercial listings pop for $1.5! Stagobox enhances images by fixing dark corners, washed-out colors & blurry details. Get market-ready images fast"
        />
      </Helmet>
      <BottomNav />

      <div className="blur-background-box">
        <div className="hp-container" data-aos="fade-up">
          <div className="page-title pt-5 pb-5 mb-5" data-aos="fade-up">
            <h1>Image Enhancement</h1>
            <p>
              <b>
                Transform your property photos with our premier image
                enhancement service, crafted to elevate the luminosity and
                vibrancy of your real estate images.
              </b>
            </p>

            <p>
              Our expert team adjusts brightness and contrast, replaces
              distracting elements like TVs, and perfects colors to ensure your
              listings stand out. We straighten images, sharpen details, and
              remove unwanted items, ensuring every photo showcases your
              property in the best light. From fixing lens distortion to adding
              a cozy fire, we handle every aspect to make your photos look
              fantastic.
            </p>
          </div>

          <div className="detailed-box mt-5">
            <div className="detail-service-card">
              <div className="detailed-text" data-aos="fade-up">
                <h3>Image Enhancement</h3>
                <ul>
                  <li>Quick Turnaround Time of 24-48 Hours</li>
                  <li>Super Rapid Delivery in just 12 hours</li>
                  <li>Enjoy unlimited Free Revisions</li>
                  <li>Enhanced Brightness and Vibrancy</li>
                  <li>100% Customization Guaranteed</li>
                  <li>Guaranteed Customer Satisfaction</li>
                  <li>Experience Professional Excellence</li>
                </ul>
                <div className="price-per-photo">
                  <h3>
                    <ConvertedPrice price={1.5} />
                  </h3>
                  <span>Per Photo</span>
                </div>
                <Link
                  to="/services/image-enhancement-form?key=Com_Image_Enhancement"
                  className="theme-btn w-100 mt-3"
                  data-aos="fade-up"
                >
                  Place an Order
                </Link>
              </div>
              {/* <div className="detailed-image" data-aos="fade-up"> */}
              <div style={{ width: "50%", height: "100%" }}>
                {/* <Carousel
                  autoplay
                  autoplaySpeed={3000}
                  arrows
                  nextArrow={<ArrowRightOutlined />}
                  prevArrow={<ArrowLeftOutlined />}
                  className="client-rating-slider"
                >
                  

                  

                 
                </Carousel> */}
                <SlickSlider
                  data={[
                    <div key={2}>
                      <div className="compare">
                        <ReactCompareSlider
                          // changePositionOnHover
                          key={2}
                          itemOne={
                            <ReactCompareSliderImage
                              style={{ minHeight: "380px" }}
                              src={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Image_Enhancement_Before_3_Web_1749847956.webp`}
                            />
                          }
                          itemTwo={
                            <ReactCompareSliderImage
                              src={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Image_Enhancement_After_3_Web_1749847955.webp`}
                            />
                          }
                        />
                        <div className="beforeafter-tag">
                          <span>Before</span>
                          <span>After</span>
                        </div>
                      </div>
                    </div>,
                    <div key={1}>
                      <div className="compare">
                        <ReactCompareSlider
                          // changePositionOnHover
                          key={2}
                          itemOne={
                            <ReactCompareSliderImage
                              style={{ minHeight: "380px" }}
                              src={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Image_Enhancement_Before_1_Web_1749847955.webp`}
                            />
                          }
                          itemTwo={
                            <ReactCompareSliderImage
                              src={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Image_Enhancement_After_1_Web_1749847955.webp`}
                            />
                          }
                        />
                        <div className="beforeafter-tag">
                          <span>Before</span>
                          <span>After</span>
                        </div>
                      </div>
                    </div>,
                    <div key={0}>
                      <div className="compare">
                        <ReactCompareSlider
                          // changePositionOnHover
                          key={0}
                          itemOne={
                            <ReactCompareSliderImage
                              style={{ minHeight: "380px" }}
                              src={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Image_Enhancement_Before_2_Web_1749847955.webp`}
                            />
                          }
                          itemTwo={
                            <ReactCompareSliderImage
                              src={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Image_Enhancement_After_2_Web_1749847955.webp`}
                            />
                          }
                        />
                        <div className="beforeafter-tag">
                          <span>Before</span>
                          <span>After</span>
                        </div>
                      </div>
                    </div>,
                  ]}
                />
              </div>
            </div>
          </div>
        </div>

        <ImpactSection impactData={impactSectionData} />

        {/* ========== How it works ========== */}
        <HowItWorks redirectionLink="/services/image-enhancement-form?key=Com_Image_Enhancement" />

        <div className="hp-container">
          {/* First time */}
          <div data-aos="fade-up">
            <FirstTime />
          </div>

          {/* Design and offer */}
          <DesignWeOfffer />

          {/* Industry we are catering */}
          <div data-aos="fade-up">
            <CaterIndustry />
          </div>

          {/* How we are different from others */}
          <div data-aos="fade-up">
            <CompareTable />
          </div>
        </div>
      </div>
    </>
  );
};

export default CommImageEnhacement;
